/* eslint-disable import/prefer-default-export */
import {
  LocalizedContentInput,
  LocalizedCreateNewsPostInput,
  LocalizedEditNewsPostInput,
} from 'apollo/localizedTypes';
import mapLocalizedText from 'utils/i18n/mapLocalizedText';
import { FormContent, CreateNewsPostFormValues } from '../types';

const mapContent = (content: FormContent): LocalizedContentInput[] => {
  const mappedContent: LocalizedContentInput[] = [];

  Object.keys(content).forEach((key) => {
    mappedContent.push({
      content: mapLocalizedText(content[key]),
      order: Number(key),
    });
  });

  return mappedContent;
};

export const mapCreateFormValues = (
  values: CreateNewsPostFormValues
): LocalizedCreateNewsPostInput => {
  const {
    title,
    publicationDate,
    content,
    coverImage,
    mainImage,
    recommendationIds,
    closingImagesIds,
    author,
  } = values;

  const mappedValues: LocalizedCreateNewsPostInput = {
    author,
    closingImagesIds: closingImagesIds?.map((imageId) => Number(imageId)) || [],
    contents: mapContent(content),
    coverImageId: Number(coverImage.id),
    mainImage: { id: Number(mainImage.id), caption: mainImage.caption },
    publicationDate: publicationDate.toISOString(),
    recommendationIds: recommendationIds.map((id) => Number(id)),
    title: mapLocalizedText(title),
  };

  return mappedValues;
};

export const mapEditFormValues = (
  values: CreateNewsPostFormValues,
  id: number
): LocalizedEditNewsPostInput => {
  const {
    title,
    publicationDate,
    content,
    coverImage,
    mainImage,
    closingImagesIds,
    recommendationIds,
    author,
  } = values;

  const mappedValues: LocalizedEditNewsPostInput = {
    id,
    contents: mapContent(content),
    coverImageId: Number(coverImage.id),
    mainImage: { id: Number(mainImage.id), caption: mainImage.caption },
    closingImagesIds: closingImagesIds?.map((imageId) => Number(imageId)) || [],
    publicationDate: publicationDate.toISOString(),
    recommendationIds: recommendationIds.map((recommendationId) =>
      Number(recommendationId)
    ),
    title: mapLocalizedText(title),
    author,
  };

  return mappedValues;
};
